import { inputOnEnterHeaderFilter } from './inputOnEnterHeaderFilter';
import { TABULATOR_LIST_ID_MIN_WIDTH } from './tabulatorColumnMinWidth';

export { TABULATOR_LIST_ID_MIN_WIDTH };

/**
 * Jednotný stĺpec ID pre maintenance Tabulator (fixed 76px).
 * Benchmark vzhľadu: mntn033 — frozen voliteľne cez opts.frozen.
 *
 * @param {object} [opts]
 * @param {boolean} [opts.frozen=false]
 * @param {Function} [opts.headerFilter=inputOnEnterHeaderFilter]
 * @param {Function} [opts.headerFilterFunc]
 * @param {object} [opts.headerFilterFuncParams]
 * @param {object} [opts.extra] — ďalšie Tabulator column props
 */
/**
 * Pri restore layoutu na flat remote Skupine A (V9d-1) — vynúti aj `frozen: true` na ID.
 * Použiť len tam, kde má stĺpec ID `buildTabulatorIdColumn({ frozen: true })`.
 */
export const TABULATOR_GROUP_A_FLAT_REMOTE_LAYOUT_SANITIZE_OPTIONS = Object.freeze({
  forceFrozenId: true,
});

/**
 * Pri restore layoutu z user/standard masky vynúti fixed šírku ID.
 * @param {object|null|undefined} node — Tabulator layout node
 * @param {{ forceFrozenId?: boolean }} [options]
 */
export function normalizeIdColumnInLayoutNode(node, options = {}) {
  if (!node || typeof node !== 'object' || Array.isArray(node) || node.field !== 'id') {
    return node;
  }
  return {
    ...node,
    width: TABULATOR_LIST_ID_MIN_WIDTH,
    minWidth: TABULATOR_LIST_ID_MIN_WIDTH,
    maxWidth: TABULATOR_LIST_ID_MIN_WIDTH,
    widthGrow: 0,
    resizable: false,
    ...(options.forceFrozenId ? { frozen: true } : {}),
  };
}

export function buildTabulatorIdColumn({
  frozen = false,
  headerFilter = inputOnEnterHeaderFilter,
  headerFilterFunc,
  headerFilterFuncParams,
  extra = {},
} = {}) {
  return {
    title: 'ID',
    field: 'id',
    width: TABULATOR_LIST_ID_MIN_WIDTH,
    minWidth: TABULATOR_LIST_ID_MIN_WIDTH,
    maxWidth: TABULATOR_LIST_ID_MIN_WIDTH,
    widthGrow: 0,
    resizable: false,
    sorter: 'number',
    hozAlign: 'left',
    headerFilterLiveFilter: false,
    ...(headerFilter != null ? { headerFilter } : {}),
    ...(headerFilterFunc != null ? { headerFilterFunc } : {}),
    ...(headerFilterFuncParams != null ? { headerFilterFuncParams } : {}),
    ...(frozen ? { frozen: true } : {}),
    ...extra,
  };
}
